import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AlertService } from 'src/app/core/services/alert.service';
import AES from 'crypto-js/aes.js';
import ENC from 'crypto-js/enc-utf8.js';
import { DbService, docJoin } from 'src/app/core/services/db.service';
import { Payment } from 'src/app/core/models/payment.models';
import { Observable } from 'rxjs';
import { LoadingService } from 'src/app/core/services/loading.service';
import { PaymentService } from 'src/app/core/services/payment.service';
import * as dayjs from 'dayjs';

@Component({
  selector: 'app-qr-info',
  templateUrl: './qr-info.component.html',
  styleUrls: ['./qr-info.component.scss'],
})
export class QrInfoComponent implements OnInit {
  ticketId = null;
  ticket$: Observable<Payment | any>;
  constructor(
    private alertService: AlertService,
    private activatedRoute: ActivatedRoute,
    private db: DbService,
    private loadingService: LoadingService,
    public paymentService: PaymentService
  ) {}

  ngOnInit() {
    const token = this.activatedRoute.snapshot.queryParams.token;
    const ticketId = this.activatedRoute.snapshot.queryParams.ticketId;
    const bytes = AES.decrypt(ticketId, token);
    this.ticketId = bytes.toString(ENC);
    this.getInfo();
  }

  // 예매한 티켓을 정보를 가져오기
  getInfo() {
    this.ticket$ = this.db
      .doc$(`payments/${this.ticketId}`)
      .pipe(docJoin(this.db.firestore, 'uuid', 'members'), docJoin(this.db.firestore, 'productId', 'products'));
  }

  // 입장 처리하기 위한 버튼
  async checkButton() {
    const ok = await this.alertService.successConfirm('한 번 입장처리 된 티켓으로는 재입장이 불가합니다. \n 입장처리 하시겠습니까?');

    if (ok) {
      this.loadingService.show();
      await this.db.updateAt(`payments/${this.ticketId}`, {
        isEnter: true,
      });

      this.loadingService.hide();
    }
  }

  // 공연 일자인지 체크하기
  isShowDate(item: Payment) {
    return dayjs(item.resDate).format('YYYYMMDD') <= dayjs().format('YYYYMMDD');
  }

  // 회차에 대한 정보를 가져오기
  getRound(payment) {
    const find = payment?.productId?.timeOption.find(v => v.time === dayjs(payment.resDate).format('HH:mm'));
    return find ? find.name : '';
  }
}
